import useHardwareFirstMembershipTerms from './useHardwareFirstMembershipTerms';

/**
 * What a GwP partner's free months lead into: the Mini+ 12-month plan at D2C's terms. Web's first-year coupon takes the
 * hardware-first 12-month intro discount, so the intro and renewal read from those terms. Undefined until they load.
 */
export default function useGwpPartnerFirstYearTerms() {
  return useHardwareFirstMembershipTerms().find((term) => term.renewalMonths === 12);
}
